import React, { useState } from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const BenefitCard = ({ title, amount, color }) => {
  const [hoverIndex, setHoverIndex] = useState(null);

  const data = [30, 50, 40, 60, 45, 55];

  return (
    <Card
      sx={{
        borderRadius: "5px",
       
        border: "1px solid #eee",
        boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
        overflow: "visible",
      }}
    >
      <CardContent 
 
> 
        <Box display="flex" justifyContent="space-between">

          {/* LEFT */}
          <Box>
            <Typography fontWeight={600}>{title}</Typography>

            <Typography fontSize={13} color="text.secondary" mt={1}>
              Per Employee
            </Typography>
          </Box>

          {/* RIGHT */}
          <Box textAlign="right" position="relative">

            {/* MINI BARS */}
            <Box
              display="flex"
              justifyContent="flex-end"
              gap={1}
              mb={1}
              position="relative"
            >
              {data.map((h, i) => (
                <Box
                  key={i}
                  onMouseEnter={() => setHoverIndex(i)}
                  onMouseLeave={() => setHoverIndex(null)}
                  sx={{
                    width: 6,
                    height: h,
                    borderRadius: 2,
                    bgcolor: color,
                    opacity: i === 0 ? 0.3 : 1,
                    cursor: "pointer",
                    transition: "0.2s",
                  }}
                />
              ))}

              {/* 🔥 TOOLTIP */}
              {hoverIndex !== null && (
                <Box
                  sx={{
                    position: "absolute",
                    top: -70,
                    right: 0,
                    background: "#fff",
                    borderRadius: "10px",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                    padding: "10px 14px",
                    fontSize: "13px",
                    minWidth: "140px",
                    zIndex: 10,
                  }}
                >
                  {/* top number */}
                  <Typography fontSize={12} mb={0.5}>
                    {hoverIndex + 1}
                  </Typography>

                  {/* content */}
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        background: color,
                      }}
                    />
                    <Typography fontSize={13}>
                      Negative: <b>-{data[hoverIndex]}</b>
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>

            <Typography fontSize={13}>{amount}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

const BenefitsCard = () => {
  return (
<Box>
  <BenefitCard
    title="Life Insurance"
    amount="$24.87"
    color="#f26522"
  />

  <Box mt="4px">
    <BenefitCard
      title="401(k) Contribution"
      amount="$10.47"
      color="#0f4c5c"
    />
  </Box>

  <Box mt="4px">
    <BenefitCard
      title="Health Insurance"
      amount="$26.87"
      color="#f4b400"
    />
  </Box>
</Box>
  );
};

export default BenefitsCard;